import React from 'react';

interface PageProps {
  url: string | undefined | null;
  children: React.ReactNode;
}

export const SlackChannelLink = ({ url, children }: PageProps) => (
  <a href={url ?? ''} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);
